import instance from '@/utils/request/index';
import { AxiosResponse } from 'axios';
export default {
  /**
   * 系统-用户编辑
   */
  async updateUserDetail(param: any) {
    const response: AxiosResponse = await instance.post('/user/edit', param);
    return response.data;
  },
  /**
   * 系统-组织创建
   */
  async createOrganization(param: any) {
    const response: AxiosResponse = await instance.post('/organization/createOrganization', param);
    return response.data;
  },
  /**
   * 系统-组织编辑
   */
  async editOrganization(param: any) {
    const response: AxiosResponse = await instance.post('/organization/editOrganization', param);
    return response.data;
  },
  /**
   * 系统-组织详情
   */
  async getOrganizationDetail(param: any) {
    const response: AxiosResponse = await instance.post('/organization/getOrganization', param);
    return response.data;
  },
  /**
  /**
   * 系统-组织列表
   */
  async getOrganizationList(param: any) {
    const response: AxiosResponse = await instance.post('/organization/getOrganizationList', param);
    return response.data;
  },
  /**
   * 系统-组织用户列表
   */
  async getUserByOrganizationId(param: any) {
    const response: AxiosResponse = await instance.post('/organization/getOrganizationUserPage', param);
    return response.data;
  },
  /**
   * 系统-组织权限列表
   */
  async getPermissionById(param: any) {
    const response: AxiosResponse = await instance.post('/organization/getPermissionByOrganizationId', param);
    return response.data;
  },
  /**
   * 系统-组织邀请用户
   */
  async inviteUser(param: any) {
    const response: AxiosResponse = await instance.post('/organization/invite', param);
    return response.data;
  },
  /**
   * 系统-组织接受邀请
   */
  async acceptInvite(param: any) {
    const response: AxiosResponse = await instance.post('/organization/inviteAccept', param);
    return response.data;
  },
  /**
   * 系统-组织切换
   */
  async switchOrganization(param: any) {
    const response: AxiosResponse = await instance.post('/user/switchOrganization', param);
    return response.data;
  },
  /**
   * 系统-组织退出
   */
  async moveOut(param: any) {
    const response: AxiosResponse = await instance.post('/organization/moveOut', param);
    return response.data;
  },
};
